//https://www.youtube.com/embed/baxlBiTqxfE?autoplay=1&rel=0&showinfo=0&controls=0&mute=1&loop=1&modestbranding=1&playsinline=1&playlist=baxlBiTqxfE&enablejsapi=1&origin=https%3A%2F%2Fwww.chouchouhotel.com&widgetid=1

function isInViewport(element) {
  var rect = element.getBoundingClientRect();
  var html = document.documentElement;
  //console.debug(rect);
  /*console.log(
    rect.bottom >= -300,
    rect.right >= 0,
    rect.top <= (window.innerHeight || html.clientHeight) + 600,
    rect.left <= (window.innerWidth || html.clientWidth)
  )
  */
  return (
    rect.bottom >= -300 &&
    rect.right >= 0 &&
    rect.top <= (window.innerHeight || html.clientHeight) + 600 &&
    rect.left <= (window.innerWidth || html.clientWidth)
  );
}

require('./hapi-background-video.scss');

// load the Javascript Player API code asynchronously.
// YOUTUBE
var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
// VIMEO
var tag = document.createElement('script');
tag.src = "https://player.vimeo.com/api/player.js";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

// then work with it
console.log('Waiting for youtube API');
window.onYouTubeIframeAPIReady = function() {
	console.log('Youtube api ready');
	window.YTConfig = { 'host': 'https://www.youtube.com' };
	setTimeout(buildBackgroundVideo,1000);
}

function buildBackgroundVideoReadCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

window.BackgroundVideoRgpdAccept = function() {
	var manager = klaro.getManager();
	manager.acceptAll();
	manager.saveAndApplyConsents();
}
window.BackgroundVideoRgpdInfo = function() {
	klaro.show();
}

window.BackgroundVideoDomNodeReinit = function(node) {

	var provider = $(node).data('backgroundVideoProvider');
	if(provider && window.hapi_background_video[provider])
		window.hapi_background_video[provider].dismountPlayer($(node))

	$(node).empty();
	$(node).removeClass('background-video-rgpd');
	$(node).removeClass('background-video-init');
	$(node).attr('data-background-video-autoload','true');

	return node;
}

function buildBackgroundVideo() {
	window.hapi_background_video.ready=true;

	if(window.hapi_background_video.queue.length > 0)
	{
		for (var i = window.hapi_background_video.queue.length - 1; i >= 0; i--) {
			var v = window.hapi_background_video.queue[i];
			window.BackgroundVideoDomNodeReinit($(v.selector)[0])
		}
		window.hapi_background_video.queue = [];
		setTimeout(buildBackgroundVideo,10);
		return ;
	}

	var rgpd_ready = false;
	if(ENV_ADMIN || ENV_CONFIG && ENV_CONFIG.rgpd_allow_video)
	{
		rgpd_ready = true;
	}

	if(!rgpd_ready) {
		var rgpd = JSON.parse(buildBackgroundVideoReadCookie('klaro'));
		rgpd_ready = rgpd && rgpd.app_analytics;
	}

	if(!rgpd_ready)
	{
		// si le RGPD n'est pas validé on ne lancera pas les vidéo mais on surveille leur validation
		$('[data-background-video]:not(.background-video-rgpd,[data-background-video-autoload="false"])').each(function(){
			var node = window.BackgroundVideoDomNodeReinit(this);
			$(node).addClass('background-video-rgpd');

			// on applique un arrière plan static si c'est possible
			var cssBackground = '';
			var imageFallback = $(node).data('backgroundVideoImage');
			if(!imageFallback)
			{
				var provider = $(node).data('backgroundVideoProvider');
				if(provider=='youtube')
				{
					var videoId = $(node).data('backgroundVideo')
					cssBackground = 'http://i3.ytimg.com/vi/'+videoId+'/hqdefault.jpg';
				}
			}
			if(imageFallback)
			{
				cssBackground = 'background-image:url(\''+imageFallback+'\');background-size:cover;background-position:center center;';
			}

			$(node).append(`<div class="background-video-rgpd-panel" style="${cssBackground}">&nbsp;</div>`);
		});
		setTimeout(buildBackgroundVideo,100);
	}
	else
	{
		$('[data-background-video]:not(.background-video-init,[data-background-video-autoload="false"])').each(function(){
			if($(this).height()>0 && isInViewport($(this)[0]))
			{
				var node = window.BackgroundVideoDomNodeReinit(this);
				$(node).addClass('background-video-init');

				var provider = $(node).data('backgroundVideoProvider');
				if(window.hapi_background_video[provider])
					window.hapi_background_video[provider].build($(node))
			}
		});
		setTimeout(buildBackgroundVideo,1000);
	}
}

window.testbuildBackgroundVideo = buildBackgroundVideo;

window.hapi_background_video = {
	ready:false,
	queue:[],
};

window.hapi_background_video.play = function(selector,sound)
{
	// if the player is already instanciated just resume the video
	var provider = $(selector).data('backgroundVideoProvider');
	if(provider=='youtube')
	{
		var id = $(selector).attr('id');
		if(window.hapi_background_video[provider] && window.hapi_background_video[provider].players[id])
		{
			window.hapi_background_video[provider].players[id].playVideo();
			return ;
		}
	}
	else if(provider=='vimeo')
	{
		var id = $(selector).attr('id');
		if(window.hapi_background_video[provider] && window.hapi_background_video[provider].players[id])
		{
			window.hapi_background_video[provider].players[id].play();
			return ;
		}
	}
	// if not, put the player in queue to be built
	window.hapi_background_video.queue.push({selector:selector,sound:sound});
}

window.hapi_background_video.stop = function(selector)
{
	var provider = $(selector).data('backgroundVideoProvider');
	if(provider=='youtube')
	{
		var id = $(selector).attr('id');
		if(window.hapi_background_video[provider] && window.hapi_background_video[provider].players[id])
			window.hapi_background_video[provider].players[id].pauseVideo();
	}
	else if(provider=='vimeo')
	{
		var id = $(selector).attr('id');
		if(window.hapi_background_video[provider] && window.hapi_background_video[provider].players[id])
			window.hapi_background_video[provider].players[id].pause();
	}
	else if(provider=='video')
	{
		$(selector).empty();
	}
}

// ---------------------------------------------------------------
// ---------------------------------------------------------------
// DIRECT VIDEO URL PROVIDER
// ---------------------------------------------------------------
// ---------------------------------------------------------------

window.hapi_background_video.video = {
	dismountPlayer:function($element)
	{
		return null;
	},
	build:function($element){
		var vegas_container = $('<div class="slide-as-background"></div>')
		$element.prepend(vegas_container);
		vegas_container.vegas({
			timer: false,
			transition: 'fade',
			slides: [
				{
					video:{
						src:[
							$element.data('backgroundVideo')
						]
					}
				}
			],
		});
	}
}

// ---------------------------------------------------------------
// ---------------------------------------------------------------
// VIMEO PROVIDER
// ---------------------------------------------------------------
// ---------------------------------------------------------------

window.hapi_background_video.vimeo = {
	index:1,
	players:{},
	dismountPlayer:function($element)
	{
		delete window.hapi_background_video.vimeo.players[$element.attr('id')];
	},
	build:function($element){
		var id = $element.data('backgroundVideo');
		var sound = $element.data('backgroundVideoSound')==1

		if(!$element.attr('id'))
			$element.attr('id','background-video-vimeo-'+window.hapi_background_video.vimeo.index++);
		$element.html('<iframe src="https://player.vimeo.com/video/'+id+'" width="100%" height="100%" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>');

		window.hapi_background_video.vimeo.ratioFix($element.attr('id'));
		$(window).on('resize',function($elementID,event){ window.hapi_background_video.vimeo.ratioFix($elementID); }.bind(null,$element.attr('id')) );

		var player = window.hapi_background_video.vimeo.players[$element.attr('id')];
		if(player)
		{
			// si leplayer est déjà initialisé on fait simplement lecture
			if($element.data('backgroundVideoSound'))
				player.setVolume(100);
			else
				player.setVolume(0);
			player.play();
		}
		else
		{
			player = new Vimeo.Player($element.find('iframe')[0]);
			window.hapi_background_video.vimeo.onPlayerReady($element,player)
			window.hapi_background_video.vimeo.players[$element.attr('id')] = player; 
			
		}

		player = window.hapi_background_video.vimeo.players[$element.attr('id')];

		if($element.attr('data-background-video-play-on')=='over')
		{
			var $player_wrapper = $element.parents('.grid_cell_wrapper').eq(0).find('.cell_container');
			$player_wrapper = $player_wrapper.length>0 ? $player_wrapper : $element.parents('.page_row_background').eq(0).find('.page_row_overlay');
			if($player_wrapper)
			{
				$player_wrapper.on('mouseover',function(player){
					player.play();
				}.bind(null,player))
			}
		}
		else if($element.attr('data-background-video-play-on')=='stay_over')
		{
			var $player_wrapper = $element.parents('.grid_cell_wrapper').eq(0).find('.cell_container');
			$player_wrapper = $player_wrapper.length>0 ? $player_wrapper : $element.parents('.page_row_background').eq(0).find('.page_row_overlay');
			if($player_wrapper)
			{
				$player_wrapper.on('mouseover',function(player){
					player.play();
				}.bind(null,player))
				$player_wrapper.on('mouseout',function(player){
					player.pause();
				}.bind(null,player))
			}
		}
		else  if($element.attr('data-background-video-play-on')=='click')
		{
			var $player_wrapper = $element.parents('.grid_cell_wrapper').eq(0).find('.cell_container');
			$player_wrapper = $player_wrapper.length>0 ? $player_wrapper : $element.parents('.page_row_background').eq(0).find('.page_row_overlay');
			if($player_wrapper)
			{
				$player_wrapper.on('click',function(player){
					if(player.getPaused())
						player.play();
					else
						player.pause();
				}.bind(null,player))
			}
		}
	},
	ratioFix:function($elementID) {
		var $element = $('#'+$elementID);

		$element.css({'width':'100%','height':'100%'});
		var container_ratio = $element.width() / $element.height();

		var video_ratio = 16/9;
		if($element.data('backgroundVideoRatio'))
		{
			//console.log($element.data('backgroundVideoRatio'));
			//console.log($element.data('backgroundVideoRatio').replace(/[^0-9.\/]/,''));
			video_ratio = eval((''+$element.data('backgroundVideoRatio')).replace(/[^0-9.\/]/,''));
			//console.log(video_ratio);
		}

		//console.log($element,container_ratio,video_ratio, $element.data('backgroundVideoRatio'));

		if(container_ratio > video_ratio)
		{
			var new_height = $element.height() * container_ratio / video_ratio;
			$element.css({
				width:'102%',
				left:'-1%',
				height:new_height + 300,
				top: ($element.height() - new_height) / 2 - 150,
			})
		}
		else
		{
			var new_width = $element.width() * video_ratio / container_ratio;
			$element.css({
				width:new_width,
				left: ($element.width() - new_width) / 2,
				height:$element.height() + 300,
				top:-150,
			})
		}
	},
	// start video when ready (mute sound if necessary)
	onPlayerReady:function($element,player) {
		if(parseInt($element.data('backgroundVideoSound'))==0)
		{
			player.setVolume(0);
		}
		if(!$element.attr('data-background-video-play-on') || $element.attr('data-background-video-play-on')=="")
		{
			var time = ($element.attr('data-background-video-time')+':').split(':');

			player.LoopOnDefinedTime_start = parseInt(time[0]);
			player.LoopOnDefinedTime_end = parseInt(time[1]);

			if(player.LoopOnDefinedTime_start>0)
			{
				player.setCurrentTime(player.LoopOnDefinedTime_start);
			}
			if(player.LoopOnDefinedTime_end>0)
			{
				player.LoopOnDefinedTime = function(){
					player.getCurrentTime().then(function(seconds) {
						if(seconds>this.LoopOnDefinedTime_end)
						{
							this.setCurrentTime(player.LoopOnDefinedTime_start);
							this.play();
						}
					}.bind(player));
					
				}
				setInterval(player.LoopOnDefinedTime.bind(player),100);
			}
			player.play();
		}
	},
}

// ---------------------------------------------------------------
// ---------------------------------------------------------------
// YOUTUBE PROVIDER
// ---------------------------------------------------------------
// ---------------------------------------------------------------
window.hapi_background_video.youtube = {
	index:1,
	players:[],
	dismountPlayer:function($element)
	{
		if(window.hapi_background_video.youtube.players[$element.attr('id')])
		{
			window.hapi_background_video.youtube.players[$element.attr('id')].destroy();
			delete window.hapi_background_video.youtube.players[$element.attr('id')];
		}
	},
	build:function($element) {
		//console.log(this);;
		if(!$element.attr('id'))
			$element.attr('id','background-video-youtube-'+window.hapi_background_video.youtube.index++);

		window.hapi_background_video.youtube.ratioFix($element.attr('id'));
		$(window).on('resize',function($elementID,event){ window.hapi_background_video.youtube.ratioFix($elementID); }.bind(null,$element.attr('id')) );

		var player = window.hapi_background_video.youtube.players[$element.attr('id')];
		if(player && player.mute)
		{
			// si leplayer est déjà initialisé on fait simplement lecture
			if($element.data('backgroundVideoSound'))
				player.unMute();
			else
				player.mute();

			player.playVideo();
		}
		else
		{
			window.hapi_background_video.youtube.players[$element.attr('id')] = new YT.Player($element.attr('id'), {
				height: '100%',
				width: '100%',
				videoId: $element.data('backgroundVideo'),
				events: {
					'onReady': window.hapi_background_video.youtube.onPlayerReady,
					'onStateChange': window.hapi_background_video.youtube.onPlayerStateChange,
				},
				playerVars: {
					'autoplay': 1,
					'rel': 0,
					'showinfo': 0,
					'controls': 0,
					'mute': 1,
					'loop': 1,
					'modestbranding': 1,
					'playsinline': 1,
				}
			});
		}

		player = window.hapi_background_video.youtube.players[$element.attr('id')];

		// update element after iframe replacement
		$element = $('#'+$element.attr('id'));
		//console.log($element);

		if($element.attr('data-background-video-play-on')=='over')
		{
			var $player_wrapper = $element.parents('.grid_cell_wrapper').eq(0).find('.cell_container');
			$player_wrapper = $player_wrapper.length>0 ? $player_wrapper : $element.parents('.page_row_background').eq(0).find('.page_row_overlay');
			if($player_wrapper.children().length==0)
				$player_wrapper = $element;
			if($player_wrapper)
			{
				$player_wrapper.on('mouseover',function(player){
					if(parseInt($element.attr('data-background-video-sound'))==1)
					{
						player.unMute();
					}
					player.playVideo();
				}.bind(null,player))
			}
		}
		else if($element.attr('data-background-video-play-on')=='stay_over')
		{
			var $player_wrapper = $element.parents('.grid_cell_wrapper').eq(0).find('.cell_container');
			$player_wrapper = $player_wrapper.length>0 ? $player_wrapper : $element.parents('.page_row_background').eq(0).find('.page_row_overlay');
			if($player_wrapper.children().length==0)
				$player_wrapper = $element;
			if($player_wrapper)
			{
				$player_wrapper.on('mouseover',function(player){
					if(parseInt($element.attr('data-background-video-sound'))==1)
					{
						player.unMute();
					}
					player.playVideo();
				}.bind(null,player))
				$player_wrapper.on('mouseout',function(player){
					player.pauseVideo();
				}.bind(null,player))
			}
		}
		else  if($element.attr('data-background-video-play-on')=='click')
		{
			var $player_wrapper = $element.parents('.grid_cell_wrapper').eq(0).find('.cell_container');
			$player_wrapper = $player_wrapper.length>0 ? $player_wrapper : $element.parents('.page_row_background').eq(0).find('.page_row_overlay');
			if($player_wrapper)
			{
				$player_wrapper.on('click',function(player){
					if(player.getPlayerState()==1)
					{
						player.pauseVideo();
					}
					else
					{
						if(parseInt($element.attr('data-background-video-sound'))==1)
						{
							player.unMute();
						}
						player.playVideo();
					}
				}.bind(null,player))
			}
		}
	},
	ratioFix:function($elementID) {
		var $element = $('#'+$elementID);

		$element.css({'width':'100%','height':'100%'});
		var container_ratio = $element.width() / $element.height();

		var video_ratio = 16/9;
		if($element.data('backgroundVideoRatio'))
		{
			//console.log($element.data('backgroundVideoRatio'));
			//console.log($element.data('backgroundVideoRatio').replace(/[^0-9.\/]/,''));
			video_ratio = eval((''+$element.data('backgroundVideoRatio')).replace(/[^0-9.\/]/,''));
			//console.log(video_ratio);
		}

		//console.log(container_ratio,video_ratio);

		if(container_ratio > video_ratio)
		{
			var new_height = $element.height() * container_ratio / video_ratio;
			$element.css({
				width:'100%',
				left:0,
				height:new_height + 300,
				top: ($element.height() - new_height) / 2 - 150,
			})
		}
		else
		{
			var new_width = $element.width() * video_ratio / container_ratio;
			$element.css({
				width:new_width,
				left: ($element.width() - new_width) / 2,
				height:$element.height() + 300,
				top:-150,
			})
		}
	},
	// start video when ready (mute sound if necessary)
	onPlayerReady:function(evt) {
		var player = evt.target;

		let $element = $(player.getIframe());
		if(parseInt($element.attr('data-background-video-sound'))==0)
		{
			player.mute();
		}
		else
		{
			if(!ENV_MOBILE && !ENV_TABLET)
				player.unMute();
		}

		var time = ($element.attr('data-background-video-time')+':').split(':');

		player.LoopOnDefinedTime_start = parseInt(time[0]);
		player.LoopOnDefinedTime_end = parseInt(time[1]);

		if(player.LoopOnDefinedTime_start>0)
		{
			player.seekTo(player.LoopOnDefinedTime_start);
		}
		if(player.LoopOnDefinedTime_end>0)
		{
			player.LoopOnDefinedTime = function(){
				if(this.getCurrentTime()>this.LoopOnDefinedTime_end)
				{
					this.seekTo(player.LoopOnDefinedTime_start);
					this.playVideo();
				}
			}
			setInterval(player.LoopOnDefinedTime.bind(player),100);
		}

		if(!$element.attr('data-background-video-play-on') || $element.attr('data-background-video-play-on')=="")
		{
			player.playVideo();
		}
		else
		{
			player.stopVideo();
		}

		if($element.attr('data-background-video-play-on')=='never')
		{
			player.stopVideo();
		}
	},
	// Autmatic video loop
	onPlayerStateChange:function(evt) {
		var player = evt.target;
		//console.log(evt.target,evt.data,YT.PlayerState);
		if(evt.data === YT.PlayerState.ENDED)
		{
			player.seekTo(player.LoopOnDefinedTime_start);
			player.playVideo();
		}
		if(evt.data === YT.PlayerState.PLAYING)
		{
			if(player.LoopOnDefinedTime_start>0)
			{
				if(
					player.getCurrentTime() < player.LoopOnDefinedTime_start
					|| player.getCurrentTime() > player.LoopOnDefinedTime_end
				)
				{
					player.seekTo(player.LoopOnDefinedTime_start);
				}
			}
		}
	}
}

setInterval(function(){
	$('.background-video-init:not([volume-button-ready])').each(function(){
		$(this).attr('volume-button-ready',1)
		var id = $(this).attr("id");
		var button = $('<button type="button" class="background-video-sound-toggle"><i class="fal fa-volume-mute"></i></button>')
		var providers = ['youtube','vimeo'];
		providers.forEach(function(provider){
			var player = window.hapi_background_video[provider] ? window.hapi_background_video[provider].players[id] : false;
			if(player)
			{
				//console.log('init',{player,provider});
				button.data('player',player);
				button.data('provider',provider);
			}
		})

		button.on('click',function(){
			var player = $(this).data('player');
			var provider = $(this).data('provider');
			var muted = false;
			if(player && provider=='youtube')
			{
				if(player.isMuted())
					player.unMute();
				else
				{
					muted = true;
					player.mute()
				}
			}
			else if(player && provider=='vimeo')
			{
				if(player.getVolume()>0)
				{
					muted = true;
					player.setVolume(0);
				}
				else
					player.setVolume(100);
			}

			if(muted)
				$(this).find('i').removeClass('fa-volume').addClass('fa-volume-mute');
			else
				$(this).find('i').removeClass('fa-volume-mute').addClass('fa-volume');
		})

		$(this).after(button)
	})
},500);